import EmailAvatar from './EmailAvatar';
import { formatAddress, formatAddressList, formatDate, formatEmailMailbox, getEmailSnippet } from './emailUtils';

function EmailList({ emails, loading, onSelect, selectedEmailId }) {
  return (
    <div className="admin-panel admin-email-list">
      {emails.map((email) => {
        return (
          <button
            className={`admin-email-row ${selectedEmailId === email._id ? 'is-active' : ''} ${
              email.readStatus === 'unread' ? 'is-unread' : ''
            }`}
            key={email._id}
            onClick={() => onSelect(email)}
            type="button"
          >
            <EmailAvatar address={email.from} />
            <div className="admin-email-row__main">
              <span className="admin-email-row__subject">{email.subject}</span>
              <span className="admin-email-row__party">
                {email.direction === 'inbound' ? formatAddress(email.from) : formatAddressList(email.to)}
              </span>
              <p>{getEmailSnippet(email) || 'No preview available.'}</p>
            </div>
            <div className="admin-email-row__meta">
              <span className="admin-email-badge">{formatEmailMailbox(email)}</span>
              <span>{email.status}</span>
              {email.attachments?.length ? <span>Attachments: {email.attachments.length}</span> : null}
              <span>{formatDate(email.sentAt || email.receivedAt || email.createdAt)}</span>
            </div>
          </button>
        );
      })}
      {loading ? <p className="admin-empty">Loading emails...</p> : null}
      {!loading && emails.length === 0 ? <p className="admin-empty">No emails found for this filter.</p> : null}
    </div>
  );
}

export default EmailList;
